<template>
  <div class="echarts" ref="el"></div>
</template>
<script>
// import * as echarts from 'echarts'
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/title'
// import 'echarts/lib/chart/bar'
// import 'echarts/lib/component/dataset'
// import 'echarts/lib/chart/pie'
// import 'echarts/lib/chart/scatter'
// import 'echarts/lib/chart/radar'
// import 'echarts/lib/chart/map'
// import 'echarts/lib/chart/tree'
// import 'echarts/lib/chart/treemap'
// import 'echarts/lib/chart/graph'
// import 'echarts/lib/chart/gauge'
// import 'echarts/lib/chart/funnel'
// import 'echarts/lib/chart/parallel'
// import 'echarts/lib/chart/sankey'
// import 'echarts/lib/chart/boxplot'
// import 'echarts/lib/chart/candlestick'
// import 'echarts/lib/chart/effectScatter'
// import 'echarts/lib/chart/lines'
// import 'echarts/lib/chart/heatmap'
// import 'echarts/lib/chart/pictorialBar'
// import 'echarts/lib/chart/themeRiver'
// import 'echarts/lib/chart/sunburst'
// import 'echarts/lib/chart/custom'
// import 'echarts/lib/component/grid'
// import 'echarts/lib/component/polar'
// import 'echarts/lib/component/geo'
// import 'echarts/lib/component/singleAxis'
// import 'echarts/lib/component/parallel'
// import 'echarts/lib/component/calendar'
// import 'echarts/lib/component/graphic'
// import 'echarts/lib/component/toolbox'
import 'echarts/lib/component/tooltip'
// import 'echarts/lib/component/axisPointer'
// import 'echarts/lib/component/brush'
// import 'echarts/lib/component/timeline'
// import 'echarts/lib/component/markPoint'
// import 'echarts/lib/component/markLine'
// import 'echarts/lib/component/markArea'
// import 'echarts/lib/component/legendScroll'
import 'echarts/lib/component/legend'
// import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/dataZoomInside'
// import 'echarts/lib/component/dataZoomSlider'
// import 'echarts/lib/component/visualMap'
// import 'echarts/lib/component/visualMapContinuous'
// import 'echarts/lib/component/visualMapPiecewise'
// import 'zrender/lib/vml/vml'
// import 'zrender/lib/svg/svg'
export default {
  props: {
    echartTitle: Array,
    xData: Array,
    yData: Array
  },
  watch: {
    xData: function(newVal, oldVal) {
      this.initEcharts()
    },
    yData: function(newVal, oldVal) {
      this.initEcharts()
    }
  },
  mounted() {
    this.initEcharts()
  },
  methods: {
    initEcharts() {
      // let isZoom = false
      // if (this.xData.length > 30) {
      //   isZoom = true
      // } else {
      //   isZoom = false
      // }
      const myChart = echarts.init(this.$refs.el)
      myChart.setOption({
        title: {
          text: this.echartTitle[0],
          subtext: this.echartTitle[1]
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true
        },
        dataZoom: [
          {
            type: 'slider',
            show: true,
            endValue: 9,
            realtime: true,
            height: 9,
            left: 5,
            right: 5,
            bottom: 0,
            fillerColor: '#e9edf5',
            borderRadio: 4,
            borderColor: '#fff',
            handleSize: 0,
            showDetail: false,
            zoomLock: true,
            moveOnMouseMove: false
          }
        ],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          left: 'right'
        },
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            interval: 0,
            width: '20px'
          },
          axisLine: {
            lineStyle: {
              // color: '#999999'
            }
          },
          data: this.xData
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true
          },
          axisTick: {
            show: true
          },
          splitNumber: 5
        },
        series: [
          {
            name: '敏感词数量',
            type: 'line',
            symbolSize: 8,
            smooth: true,
            lineStyle: {
              color: '#85A5FF',
              width: 3
            },
            itemStyle: {
              color: '#85A5FF'
            },
            label: {
              normal: {
                show: true,
                position: 'top'
              }
            },
            data: this.yData
          }
        ]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.echarts {
  width: 100%;
  height: 420px;
  margin-bottom: 20px;
}
</style>
